export const MAX_VISIBLE_DATE_PILLS = 5;
export const ALL_DATES_PILL_LABEL = 'All Dates';
export const DATE_FILTER_PILL_GAP = 10;

export interface DatePillWidth {
  label: string;
  width: number;
}

export const splitDatesByVisibleCount = (
  dates: string[],
  maxVisibleDatePills: number,
): { visibleDates: string[]; hiddenDates: string[] } => {
  if (dates.length <= maxVisibleDatePills) {
    return { visibleDates: dates, hiddenDates: []};
  }

  return {
    visibleDates: dates.slice(0, maxVisibleDatePills),
    hiddenDates: dates.slice(maxVisibleDatePills),
  };
};

export const splitVisibleAndHiddenPillLabels = (
  pillWidths: DatePillWidth[],
  availablePillWidth: number,
  gap = 0,
): { visibleLabels: string[]; hiddenLabels: string[] } => {
  let usedWidth = 0;
  let visibleCount = 0;
  let startIndex = 0;

  if (pillWidths[0]?.label === ALL_DATES_PILL_LABEL) {
    usedWidth = pillWidths[0].width;
    visibleCount = 1;
    startIndex = 1;
  }

  for (let index = startIndex; index < pillWidths.length; index += 1) {
    const gapBefore = visibleCount > 0 ? gap : 0;
    if (usedWidth + gapBefore + pillWidths[index].width > availablePillWidth) {
      break;
    }
    usedWidth += gapBefore + pillWidths[index].width;
    visibleCount = index + 1;
  }

  const visibleLabels = pillWidths.slice(0, visibleCount).map((pill) => pill.label);
  const hiddenLabels = pillWidths.slice(visibleCount).map((pill) => pill.label);

  return { visibleLabels, hiddenLabels };
};
